import React from 'react';
import fr from 'facet-rest';
import {
  FDPrimaryActionButton,
  FDList,
  FDListItem,
  FDListItemText,
  FDBodyText,
  FDListItemSecondary, FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

// This layout is intended to be used for the Create Your Plan wizard steps that show boxes
// with information to confirm and allow the user to click an edit or continue link.
const CreateYourPlanReviewStepLayout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();

  const onClickForRel = (relName) => resource.withRelationship(relName, (rel) => {
    if (rel.meta('modal') === 'true') {
      loadModalCollectionByLink(rel.link('related').url());
      return;
    }
    loadPageContentLink(rel.link('related'));
    clearModalCollection();
  }, () => undefined);

  const editBtnForRel = (relName) => resource.withRelationship(relName, () => (
    <FDListItemSecondary>
      <FDSecondaryActionIconButton icon="edit" onClick={() => onClickForRel(relName)} />
    </FDListItemSecondary>
  ), () => null);

  const listItemTextForAttr = (attrName) => (
    <FDListItemText
      primaryText={resource.metaField(attrName).attr('prompt')}
      secondaryText={(
        <>
          {resource.attr(attrName)?.resources()?.list()?.map(res => <FDBodyText size="sm" key={res.id()} value={res.attr('name')} color="textAttention" />)}
        </>
      )}
    />
  );

  const listItem = (relName, attrName) => (
    <FDListItem onClick={() => onClickForRel(relName)}>
      {listItemTextForAttr(attrName)}
      {editBtnForRel(relName)}
    </FDListItem>
  );

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent>
        <FDList variant="separated">
          {listItem(fr.relationships.editHousehold.name, 'householdErrors')}
          {listItem(fr.relationships.editIncome.name, 'incomeErrors')}
          {listItem(fr.relationships.editExpenses.name, 'expenseErrors')}
          {listItem(fr.relationships.editAssets.name, 'assetErrors')}
          {listItem(fr.relationships.editLiabilities.name, 'liabilityErrors')}
        </FDList>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionButton
          label={'This looks right →'}
          onClick={onSubmit}
          loading={saving}
          disabled={!resource.meta().canPost()}
          {...dataAttrs('create-your-plan-continue-btn')}
        />
      </DialogActions>
    </>
  );
};

export default CreateYourPlanReviewStepLayout;
